import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      Made with <span className="heart">❤️</span> by <strong>Invite Avenue</strong>
    </footer>
  );
}

export default Footer; 